// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-mapping-pop-up {
  display: flex;
}
.products-mapping-pop-up .modals-wrap {
  width: 100%;
}
.products-mapping-pop-up button.erp-list-search-btn {
  height: 56px;
  background: #e5e5e5;
  border-radius: 0;
}
.products-mapping-pop-up .modal-main {
  padding-inline: 0;
  max-width: 463px;
  padding-block: 18px;
  top: auto;
  bottom: auto;
}
.products-mapping-pop-up .modal-main:has(.map-erp-product-with-price-popup) {
  max-width: 680px;
  min-width: 680px;
}
.products-mapping-pop-up .modal-main:has(.change-erp-product-price-popup) {
  max-width: 444px;
}
.products-mapping-pop-up .modal-main .error-in-mapping {
  font-family: var(--font-family);
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  padding-block: 0;
  color: #dc3545;
  text-align: center;
  margin-top: 4px;
}
.products-mapping-pop-up .modal-close-btn {
  color: #333333;
  height: 21px;
  width: 23px;
  top: 17px;
}
.products-mapping-pop-up .modal-header {
  display: block;
  margin-bottom: 0px;
  margin-inline: -3px;
  padding-inline: 37px;
  border-bottom: 1px solid #D2D2D2;
  padding-bottom: 17px;
  text-align: center;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.18px;
}
.products-mapping-pop-up .modal-content {
  padding-inline: 37px;
  margin-inline: -3px;
  padding-block: 20px;
  font-family: var(--font-family);
}
.products-mapping-pop-up .radio-option-product-img-title-wrap {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
}
.products-mapping-pop-up .radio-option-product-img {
  max-width: 81px;
  max-height: 81px;
  height: 100%;
  width: 100%;
  padding: 21px 14px;
  border-radius: 6px;
  background: #F8F8F8;
  border: 1px solid #F8F8F8;
}
.products-mapping-pop-up .radio-option-product-title {
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #333;
  max-width: 182px;
}
.products-mapping-pop-up .map-erp-product-popup .modal-content-header {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 27.5px;
  text-align: center;
}
.products-mapping-pop-up .map-erp-product-popup .modal-search-wrap {
  margin-block: 20px 40px;
}
.products-mapping-pop-up .modal-content {
  overflow-y: auto;
  max-height: 66vh;
}
.products-mapping-pop-up .modal-content::-webkit-scrollbar-thumb {
  background-color: #ACACAC;
  width: 6px;
}
.products-mapping-pop-up .modal-content::-webkit-scrollbar {
  width: 6px;
  background: #EFEFEF;
  border-radius: 10px;
}
.products-mapping-pop-up .modal-button-wrap button {
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.14px;
  max-width: 190px;
  width: 100%;
  color: #fff;
  border-radius: 60px;
  background: #6ECB44;
  padding: 12px 20px;
  text-align: center;
}
.products-mapping-pop-up .modal-button-wrap {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  border-top: 1px solid #D2D2D2;
  margin-inline: -3px;
}
.products-mapping-pop-up input::-webkit-search-cancel-button {
  display: none;
}
.products-mapping-pop-up .change-erp-product-price-popup span.mat-prefix,
.products-mapping-pop-up .non-erp-newly-mapped span.mat-prefix {
  width: 38px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 5px 0px 0px 5px;
  border-right: 1px solid #D2D2D2;
  background: #EDEDED;
  justify-content: center;
  margin-right: 4px;
}
.products-mapping-pop-up .change-erp-product-price-popup .effective-wrap mat-icon.date-clear-btn {
  opacity: 0.7;
  cursor: pointer;
  display: inline-block;
}
.products-mapping-pop-up .change-erp-product-price-popup span.mat-prefix {
  border-right: none;
  margin-right: 0px;
  width: auto;
  padding-left: 10px;
  background-color: inherit;
}
.products-mapping-pop-up .map-erp-product-with-price-popup .modal-content-header {
  font-family: var(--font-family);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 27.5px;
  text-align: center;
  max-width: 380px;
  margin: auto;
  margin-bottom: 20px;
}
.products-mapping-pop-up .map-erp-product-with-price-popup .mat-mdc-radio-button .mdc-form-field {
  width: 100%;
}
.products-mapping-pop-up .map-erp-product-with-price-popup .radio-option-title-input-grp {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.products-mapping-pop-up .change-erp-product-price-popup .modal-content-main.data_filter {
  display: flex;
  gap: 28px;
  min-height: 90px;
}
.products-mapping-pop-up .change-erp-product-price-popup .new-price-label,
.products-mapping-pop-up .change-erp-product-price-popup .existing-price-label {
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 10px;
  padding-bottom: 15px;
}
.products-mapping-pop-up .change-erp-product-price-popup .modal-content-product-title {
  font-family: var(--font-family);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  padding-bottom: 10px;
}
.products-mapping-pop-up .change-erp-product-price-popup .modal-content-product-sku {
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 10px;
  padding-bottom: 40px;
  text-align: center;
}
.products-mapping-pop-up .change-erp-product-price-popup .modal-button-wrap {
  padding-inline: 57px;
}
.products-mapping-pop-up .change-erp-product-price-popup .modal-button-wrap button {
  width: 100%;
  max-width: 100%;
}
.products-mapping-pop-up .change-erp-product-price-popup .modal-button-wrap button:disabled {
  background-color: #9B9B9B;
}
.products-mapping-pop-up .change-erp-product-price-popup .effective-date-wrap .suggested-effective-date-wrap {
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  padding-bottom: 10px;
  display: flex;
  gap: 10px;
  padding-top: 10px;
}
.products-mapping-pop-up .change-erp-product-price-popup .effective-date-wrap .suggested-effective-date-label {
  font-weight: 500;
}
.products-mapping-pop-up .change-erp-product-price-popup .effective-date-wrap .effective-date-value {
  margin-block: 10px;
}
.products-mapping-pop-up .change-erp-product-price-popup .modal-content {
  padding-inline: 57px;
}

.high-price-confirmation-popup .modal-main {
  padding: 39px 26px;
}
.high-price-confirmation-popup .modal-header {
  margin-bottom: 0;
}
.high-price-confirmation-popup .modal-close-btn {
  width: 18px;
  height: 18px;
}
.high-price-confirmation-popup .modal-heading-main {
  color: #333;
  text-align: center;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.18px;
  padding-bottom: 24px;
}
.high-price-confirmation-popup .submit-btn-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 24px;
  gap: 20px;
}
.high-price-confirmation-popup .modal-description {
  color: #4C5258;
  text-align: center;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  max-width: 318px;
  width: 100%;
  margin: auto;
}
.high-price-confirmation-popup .btn-yes {
  color: #FFF;
  text-align: center;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  line-height: 12px;
  border-radius: 60px;
  background: #6ECB44;
  padding-block: 14px;
  width: 94px;
}
.high-price-confirmation-popup .btn-cancel {
  border-radius: 60px;
  border: 1px solid #6ECB44;
  color: #6ECB44;
  text-align: center;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  line-height: 12px;
  padding-block: 14px;
  width: 94px;
}

.confirm-mapping-with-date .effective-wrap mat-icon.date-clear-btn {
  opacity: 0.7;
  cursor: pointer;
  display: inline-block;
}

.confirm-mapping-with-date .suggested-effective-date-wrap {
  font-size: 16px;
  display: flex;
  gap: 5px;
  margin-block: 25px 15px;
}
.confirm-mapping-with-date button.btn-yes {
  background: #6ECB44;
  color: #FFFFFF;
  font-size: 12px;
  line-height: 14px;
  padding: 15px 25px;
}
.confirm-mapping-with-date .submit-btn-wrap {
  display: flex;
  gap: 15px;
  margin-block: 25px 0px;
}
.confirm-mapping-with-date button.btn-cancel {
  border-color: #6ECB44;
  color: #6ECB44;
  font-size: 12px;
  line-height: 14px;
  padding: 15px 25px;
}
.confirm-mapping-with-date .modal-close-btn {
  width: 18px;
  height: 18px;
  right: 14px;
  top: 16px;
}
.confirm-mapping-with-date .effective-wrap {
  margin-block: 25px;
}
.confirm-mapping-with-date .modal-header {
  margin: 0;
}
.confirm-mapping-with-date .modal-heading-main {
  font-weight: 600;
  text-align: center;
}

@media screen and (max-width: 767px) {
  .products-mapping-pop-up .map-erp-product-with-price-popup .radio-option-title-input-grp {
    flex-direction: column;
    align-items: start;
    gap: 15px;
    max-width: 182px;
  }
  .products-mapping-pop-up .modal-main:has(.map-erp-product-with-price-popup) {
    max-width: 480px;
    min-width: 480px;
  }
  .products-mapping-pop-up .radio-option-product-img-title-wrap {
    justify-content: space-between;
  }
  .products-mapping-pop-up .modal-content {
    padding-inline: 25px;
  }
}
@media screen and (max-width: 592px) {
  .products-mapping-pop-up .modal-main {
    max-width: 400px;
  }
  .products-mapping-pop-up .modal-main:has(.map-erp-product-with-price-popup) {
    max-width: 400px;
    min-width: 400px;
  }
}
@media screen and (max-width: 492px) {
  .confirm-mapping-with-date {
    max-width: 340px;
  }
  .products-mapping-pop-up .modal-main {
    max-width: 330px;
  }
  .products-mapping-pop-up .modal-main:has(.map-erp-product-with-price-popup) {
    max-width: 330px;
    min-width: 330px;
  }
  .products-mapping-pop-up .modal-main:has(.change-erp-product-price-popup) {
    max-width: 330px;
  }
  .products-mapping-pop-up .change-erp-product-price-popup .modal-content-main.data_filter {
    flex-direction: column;
    gap: 15px;
  }
  .products-mapping-pop-up .change-erp-product-price-popup .effective-date-wrap .suggested-effective-date-wrap {
    font-size: 12px;
    padding-top: 15px;
  }
  .products-mapping-pop-up .change-erp-product-price-popup .modal-content {
    padding-inline: 20px;
  }
  .products-mapping-pop-up .modal-content {
    padding-inline: 15px;
  }
  .products-mapping-pop-up .radio-option-product-img-title-wrap {
    gap: 15px;
    margin-left: 10px;
  }
  .products-mapping-pop-up .modal-header {
    font-size: 15px;
  }
  .products-mapping-pop-up .map-erp-product-popup .modal-content-header,
  .products-mapping-pop-up .map-erp-product-with-price-popup .modal-content-header {
    font-size: 14px;
    line-height: 20px;
  }
  .high-price-confirmation-popup .modal-main {
    padding: 29px 16px;
    max-width: 330px;
  }
}
.product_status {
  text-align: center;
  font-size: 16px;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/products/products-mapping-popups/products-mapping-popups.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AAAI;EACI,WAAA;AAER;AACI;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;AACR;AACI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AACR;AAAQ;EACI,gBAAA;EACA,gBAAA;AAEZ;AACQ;EACI,gBAAA;AACZ;AACQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AACZ;AAEI;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAAR;AAEI;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,oBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAAR;AAEI;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;AAAR;AAII;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AAFR;AAII;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAFR;AAII;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAFR;AAKQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAHZ;AAKQ;EACI,uBAAA;AAHZ;AAOI;EACI,gBAAA;EACA,gBAAA;AALR;AAOI;EAEI,yBAAA;EACA,UAAA;AANR;AAQI;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;AANR;AASI;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAPR;AASI;EACI,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;AAPR;AASI;EACI,aAAA;AAPR;AASI;;EAEQ,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAPZ;AAYY;EACI,YAAA;EACA,eAAA;EACA,qBAAA;AAVhB;AAgBI;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AAdR;AAkBQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAhBZ;AAkBQ;EACI,WAAA;AAhBZ;AAkBQ;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAhBZ;AAoBQ;EACI,aAAA;EACA,SAAA;EACA,gBAAA;AAlBZ;AAoBQ;;EAEI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAlBZ;AAoBQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAlBZ;AAoBQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AAlBZ;AAoBQ;EACI,oBAAA;AAlBZ;AAmBY;EACI,WAAA;EACA,eAAA;AAjBhB;AAkBgB;EACI,yBAAA;AAhBpB;AAqBY;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;AAnBhB;AAqBY;EACI,gBAAA;AAnBhB;AAqBY;EACI,kBAAA;AAnBhB;AAsBQ;EACI,oBAAA;AApBZ;;AA0BI;EACI,kBAAA;AAvBR;AAyBI;EACI,gBAAA;AAvBR;AAyBI;EACI,WAAA;EACA,YAAA;AAvBR;AAyBI;EACI,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;AAvBR;AAyBI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;AAvBR;AAyBI;EACI,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAvBR;AA0BI;EACQ,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EAEA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAzBZ;AA2BI;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAzBR;;AA+BQ;EACI,YAAA;EACA,eAAA;EACA,qBAAA;AA5BZ;;AAkCI;EACI,eAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;AA/BR;AAiCI;EACI,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA/BR;AAiCI;EACI,aAAA;EACA,SAAA;EACA,sBAAA;AA/BR;AAiCI;EACI,qBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA/BR;AAiCI;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AA/BR;AAiCI;EACI,kBAAA;AA/BR;AAiCI;EACI,SAAA;AA/BR;AAiCI;EACI,gBAAA;EACA,kBAAA;AA/BR;;AAmCA;EAIY;IACI,sBAAA;IACA,kBAAA;IACA,SAAA;IACA,gBAAA;EAnCd;EAuCU;IACI,gBAAA;IACA,gBAAA;EArCd;EAwCM;IACI,8BAAA;EAtCV;EAwCM;IACI,oBAAA;EAtCV;AACF;AA2CA;EAGQ;IACI,gBAAA;EA3CV;EA4CU;IACI,gBAAA;IACA,gBAAA;EA1Cd;AACF;AA8CA;EACI;IACI,gBAAA;EA5CN;EA+CM;IACI,gBAAA;EA7CV;EA8CU;IACI,gBAAA;IACA,gBAAA;EA5Cd;EA8CU;IACI,gBAAA;EA5Cd;EAiDU;IACI,sBAAA;IACA,SAAA;EA/Cd;EAkDc;IACI,eAAA;IACA,iBAAA;EAhDlB;EAqDU;IACI,oBAAA;EAnDd;EAsDM;IACI,oBAAA;EApDV;EAsDM;IACM,SAAA;IACA,iBAAA;EApDZ;EAsDM;IACI,eAAA;EApDV;EAyDU;;IACI,eAAA;IACA,iBAAA;EAtDd;EA4DM;IACI,kBAAA;IACA,gBAAA;EA1DV;AACF;AAkEA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AAhEJ","sourcesContent":[".products-mapping-pop-up{\n    display: flex;\n    .modals-wrap{\n        width: 100%;\n      \n    }\n    button.erp-list-search-btn {\n        height: 56px;\n        background: #e5e5e5;\n        border-radius: 0;\n    }\n    .modal-main{\n        padding-inline: 0;\n        max-width: 463px;\n        padding-block: 18px;\n        top: auto;\n        bottom: auto;\n        &:has(.map-erp-product-with-price-popup){\n            max-width: 680px;\n            min-width: 680px;\n\n        }\n        &:has(.change-erp-product-price-popup){\n            max-width: 444px;\n        }\n        .error-in-mapping{\n            font-family:  var(--font-family);\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 500;\n            padding-block: 0;\n            color: #dc3545;\n            text-align: center;\n            margin-top: 4px;\n        }\n    }\n    .modal-close-btn {\n        color: #333333;\n        height: 21px;\n        width: 23px;\n        top: 17px;\n    }\n    .modal-header {\n        display: block;\n        margin-bottom: 0px;\n        margin-inline: -3px;\n        padding-inline: 37px;\n        border-bottom: 1px solid #D2D2D2;\n        padding-bottom: 17px;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px;\n        letter-spacing: 0.18px;\n    }\n    .modal-content {\n        padding-inline: 37px;\n        margin-inline: -3px;\n        padding-block: 20px;\n        font-family:  var(--font-family);\n       \n    }\n  \n    .radio-option-product-img-title-wrap {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        margin-bottom: 20px;\n        margin-left: 20px;\n    }\n    .radio-option-product-img {\n        max-width: 81px;\n        max-height: 81px;\n        height: 100%;\n        width: 100%;\n        padding: 21px 14px;\n        border-radius: 6px;\n        background: #F8F8F8;\n        border: 1px solid #F8F8F8;\n    }\n    .radio-option-product-title {\n        font-family:  var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        color: #333;\n        max-width: 182px;\n    }\n    .map-erp-product-popup{\n        .modal-content-header{\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 27.5px;\n            text-align: center;\n        }\n        .modal-search-wrap{\n            margin-block: 20px 40px;\n        }\n       \n    }\n    .modal-content {\n        overflow-y: auto;\n        max-height: 66vh;\n    }\n    .modal-content::-webkit-scrollbar-thumb\n    {\n        background-color:#ACACAC;\n        width: 6px;\n    }\n    .modal-content::-webkit-scrollbar {\n        width: 6px;\n        background: #EFEFEF;\n        border-radius: 10px;\n    }\n  \n    .modal-button-wrap button {\n        font-family:  var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 20px;\n        letter-spacing: 0.14px;\n        max-width: 190px;\n        width: 100%;\n        color: #fff;\n        border-radius: 60px;\n        background: #6ECB44;\n        padding: 12px 20px;\n        text-align: center;\n    }\n    .modal-button-wrap {\n        display: flex;\n        justify-content: center;\n        padding-top: 20px;\n        border-top: 1px solid #D2D2D2;\n        margin-inline: -3px;\n    }\n    input::-webkit-search-cancel-button{\n        display: none;\n    }\n    .change-erp-product-price-popup  span.mat-prefix,\n    .non-erp-newly-mapped span.mat-prefix {\n            width: 38px;\n            height: 40px;\n            display: flex;\n            align-items: center;\n            border-radius: 5px 0px 0px 5px;\n            border-right: 1px solid #D2D2D2;\n            background: #EDEDED;\n            justify-content: center;\n            margin-right: 4px;\n    }\n    \n    .change-erp-product-price-popup{\n        .effective-wrap{\n            mat-icon.date-clear-btn {\n                opacity: 0.7;\n                cursor: pointer;\n                display: inline-block;\n            }\n        }\n       \n    }\n  \n    .change-erp-product-price-popup span.mat-prefix{\n        border-right:none;\n        margin-right: 0px;\n        width: auto;\n        padding-left: 10px;\n        background-color: inherit;\n    }\n    \n    .map-erp-product-with-price-popup{\n        .modal-content-header {\n            font-family:  var(--font-family);\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 27.5px;\n            text-align: center;\n            max-width: 380px;\n            margin: auto;\n            margin-bottom: 20px;\n        }\n        .mat-mdc-radio-button .mdc-form-field{\n            width: 100%;\n        }\n        .radio-option-title-input-grp{\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n            align-items: center;\n        }\n    }\n    .change-erp-product-price-popup{\n        .modal-content-main.data_filter {\n            display: flex;\n            gap: 28px;\n            min-height: 90px;\n        }\n        .new-price-label,\n        .existing-price-label {\n            font-family:  var(--font-family);\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 10px;\n            padding-bottom: 15px;\n        }\n        .modal-content-product-title {\n            font-family:  var(--font-family);\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n            text-align: center;\n            padding-bottom: 10px;\n        }\n        .modal-content-product-sku {\n            font-family:  var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 10px;\n            padding-bottom: 40px;\n            text-align: center;\n        }\n        .modal-button-wrap{\n            padding-inline: 57px;\n            button{\n                width: 100%;\n                max-width: 100%;\n                &:disabled{\n                    background-color: #9B9B9B;\n                }\n            }\n        }\n        .effective-date-wrap{\n            .suggested-effective-date-wrap {\n                font-family:  var(--font-family);\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 17px;\n                padding-bottom: 10px;\n                display: flex;\n                gap: 10px;\n                padding-top: 10px;\n            }\n            .suggested-effective-date-label {\n                font-weight: 500;\n            }\n            .effective-date-value {\n                margin-block: 10px;\n            }\n        }\n        .modal-content{\n            padding-inline: 57px;\n        }\n    }\n    \n}\n.high-price-confirmation-popup{\n    .modal-main{\n        padding: 39px 26px;\n    }\n    .modal-header{\n        margin-bottom: 0;\n    }\n    .modal-close-btn{\n        width: 18px;\n        height: 18px;\n    }\n    .modal-heading-main {\n        color: #333;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px;\n        letter-spacing: 0.18px;\n        padding-bottom: 24px;\n    }\n    .submit-btn-wrap {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding-top: 24px;\n        gap: 20px;\n    }\n    .modal-description {\n        color: #4C5258;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 24px;\n        max-width: 318px;\n        width: 100%;\n        margin: auto;\n\n    }\n    .btn-yes {\n            color: #FFF;\n            text-align: center;\n            font-family:  var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            \n            line-height: 12px;\n            border-radius: 60px;\n            background: #6ECB44;\n            padding-block: 14px;\n            width: 94px;\n    }\n    .btn-cancel{\n        border-radius: 60px;\n        border: 1px solid #6ECB44;\n        color: #6ECB44;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 12px;\n        font-style: normal;\n        line-height: 12px;\n        padding-block: 14px;\n        width: 94px;\n    } \n\n}\n.confirm-mapping-with-date{\n    .effective-wrap{\n        mat-icon.date-clear-btn {\n            opacity: 0.7;\n            cursor: pointer;\n            display: inline-block;\n        }\n    }\n}\n.confirm-mapping-with-date{\n   \n    .suggested-effective-date-wrap{\n        font-size: 16px;\n        display: flex;\n        gap: 5px;\n        margin-block: 25px 15px;\n    }\n    button.btn-yes {\n        background: #6ECB44;\n        color: #FFFFFF;\n        font-size: 12px;\n        line-height: 14px;\n        padding: 15px 25px;\n    }\n    .submit-btn-wrap {\n        display: flex;\n        gap: 15px;\n        margin-block: 25px 0px;\n    }\n    button.btn-cancel{\n        border-color: #6ECB44;\n        color: #6ECB44;\n        font-size: 12px;\n        line-height: 14px;\n        padding: 15px 25px;\n    }\n    .modal-close-btn{\n        width: 18px;\n        height: 18px;\n        right: 14px;\n        top: 16px;\n    }\n    .effective-wrap {\n        margin-block: 25px;\n    }\n    .modal-header{\n        margin: 0;\n    }\n    .modal-heading-main{\n        font-weight: 600;\n        text-align: center;\n    }\n    \n}\n@media screen and (max-width:767px) {\n    .products-mapping-pop-up{\n        .map-erp-product-with-price-popup\n        {   \n            .radio-option-title-input-grp{\n                flex-direction: column;\n                align-items: start;\n                gap: 15px;\n                max-width: 182px;\n            }\n        }\n        .modal-main{\n            &:has(.map-erp-product-with-price-popup){\n                max-width: 480px;\n                min-width: 480px;\n            }\n        }\n        .radio-option-product-img-title-wrap{\n            justify-content: space-between;\n        }\n        .modal-content{\n            padding-inline: 25px;\n        }\n    }\n   \n}\n\n@media screen and (max-width:592px) {\n    .products-mapping-pop-up{\n       \n        .modal-main{\n            max-width: 400px;\n            &:has(.map-erp-product-with-price-popup){\n                max-width: 400px;\n                min-width: 400px;\n            }\n        }\n    }\n}\n@media screen and (max-width:492px) {\n    .confirm-mapping-with-date{\n        max-width: 340px;\n    }\n    .products-mapping-pop-up{\n        .modal-main{\n            max-width: 330px;\n            &:has(.map-erp-product-with-price-popup){\n                max-width: 330px;\n                min-width: 330px;\n            }\n            &:has(.change-erp-product-price-popup){\n                max-width: 330px;\n            }\n        }\n        .change-erp-product-price-popup\n          {\n            .modal-content-main.data_filter {\n                flex-direction: column;\n                gap: 15px;\n            }\n            .effective-date-wrap{\n                .suggested-effective-date-wrap {\n                    font-size: 12px;\n                    padding-top: 15px;\n                }\n            }\n         }\n         .change-erp-product-price-popup{\n            .modal-content{\n                padding-inline: 20px;\n            }\n         }\n        .modal-content{\n            padding-inline: 15px;\n        }\n        .radio-option-product-img-title-wrap{\n              gap: 15px;\n              margin-left: 10px;\n        }\n        .modal-header{\n            font-size: 15px;\n        }\n  \n        .map-erp-product-popup,\n        .map-erp-product-with-price-popup{\n            .modal-content-header{\n                font-size: 14px;\n                line-height: 20px;\n            \n            }\n        }\n    }\n    .high-price-confirmation-popup{\n        .modal-main{\n            padding: 29px 16px;\n            max-width: 330px;\n        }\n        \n    }\n\n}\n\n\n\n.product_status{\n    text-align: center;\n    font-size: 16px;\n    opacity: .5;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
